<template>
  <v-select
    hide-details="auto"
    :items="status"
    v-model="filterDatas.paymenType"
    item-text="name"
    item-value="id"
    label="Payment Type"
    outlined
    clearable
    dense
    @change="emitInput(filterDatas.paymenType)"
  ></v-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    status: [
      {
        id: 'Cash',
        name: 'Cash',
      },
      {
        id: 'Card',
        name: 'Card',
      },
      {
        id: 'Cheque',
        name: 'Cheque',
      },
    ],
    selectStatus: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_PAYMENT_TYPE_FILTER', data);

      this.$emit('input', this.filterDatas.paymenType);
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectStatus = null;
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.paymenType);
  },
};
</script>
